import React from 'react';
import './AboutCodeXLNC.css'; // Create this CSS file (provided below)
import { Link } from 'react-router-dom';
// import { FaWhatsapp, FaLinkedin, FaEnvelope, FaChalkboardTeacher, FaLaptopCode, FaUserTie, FaBriefcase } from 'react-icons/fa';
import {
  FaWhatsapp,
  FaLinkedin,
  FaEnvelope,
  FaChalkboardTeacher,
  FaLaptopCode,
  FaUserTie,
  FaBriefcase,
  FaCloud,

} from 'react-icons/fa';

import { SiSalesforce, SiReact, SiJavascript } from 'react-icons/si';
const AboutCodeXLNC = () => {
  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Welcome to <span className="highlight">CodeXLNC</span></h1>
          <h2>Salesforce + AI & MERN Stack Specialists</h2>
          <p>Transforming beginners into industry-ready developers with cutting-edge training</p>
          <div className="cta-buttons">
            
            {/* <a href="#courses" className="btn primary">Explore Courses</a> */}
            <Link to="/courses" className="btn primary">Explore Courses</Link>

            <a href="#contact" className="btn secondary">
              {/* <link to="/contact" className="btn secondary"> */}
              <FaWhatsapp /> Chat Now
            </a>
          </div>
        </div>
      </section>

      {/* Specialization Section */}
      <section className="specialization-section">
        <h2>Our <span className="highlight">Core Expertise</span></h2>
        <div className="expertise-cards">
          <div className="expertise-card">
            <div className="icon-box salesforce">
            <SiSalesforce size={70} color="#00A1E0" />
            </div>
            <h3>Salesforce with AI</h3>
            <ul>  
              <li>Salesforce Admin & Developer</li>
              <li>LWC & Apex Programming</li>
              <li>Einstein AI Integration</li>
              <li>CRM Automation</li>
            </ul>
          </div>
          
          <div className="expertise-card">
            <div className="icon-box mern">
              <SiReact size={100} color="#61DAFB" />
              <SiJavascript size={100} color="#F7DF1E" />
              <FaCloud size={70} color="#5ED3F3" />
             
            </div>
            <h3>MERN Stack</h3>
            <ul>
              <li>MongoDB + Express + React + Node</li>
              <li>Full Stack Development</li>
              <li>RESTful APIs & Microservices</li>
              <li>JWT Authentication</li>
            </ul>
          </div>
          
          <div className="expertise-card">
            <div className="icon-box placement">
              <FaLaptopCode className="icon" />
              <FaUserTie className="icon" />
              <FaBriefcase className="icon" />
              
            </div>
            <h3>Placement Focus</h3>
            <ul>
              <li>Resume Building</li>
              <li>Technical Interview Prep</li>
              <li>Mock HR Sessions</li>
              <li>Direct Company Tie-ups</li>
            </ul>
          </div>
        </div>
      </section>


      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <h2>Why <span className="highlight">CodeXLNC</span> Stands Out</h2>
        <div className="features-grid">
          <div className="feature">
            <FaLaptopCode className="feature-icon" />
            <h3>Project-Based Learning</h3>
            <p>Work on 5+ real-world projects including Salesforce CRM implementations and full-stack applications</p>
          </div>
          
          <div className="feature">
            <FaChalkboardTeacher className="feature-icon" />
            <h3>Industry Expert Trainers</h3>
            <p>Learn from certified Salesforce architects and MERN stack developers with 8+ years experience</p>
          </div>
          
          <div className="feature">
            <FaUserTie className="feature-icon" />
            <h3>Career Transition Support</h3>
            <p>Special programs for non-IT professionals to enter tech industry</p>
          </div>
          
          <div className="feature">
            <FaBriefcase className="feature-icon" />
            <h3>Guaranteed Interviews</h3>
            <p>Access to our partner network of 150+ hiring companies</p>
          </div>
        </div>
      </section>

      {/* Success Metrics */}
      <section className="metrics-section">
        <h2>Our <span className="highlight">Impact</span></h2>
        <div className="metrics-grid">
          <div className="metric">
            <h3>120+</h3>
            <p>Salesforce Developers Trained</p>
          </div>
          <div className="metric">
            <h3>80+</h3>
            <p>MERN Stack Graduates</p>
          </div>
          <div className="metric">
            <h3>87%</h3>
            <p>Placement Rate</p>
          </div>
          <div className="metric">
            <h3>₹18LPA</h3>
            <p>Highest Package (Salesforce)</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <h2>Ready to <span className="highlight">Transform</span> Your Career?</h2>
        <div className="contact-methods">
          <a href="https://wa.me/916309012237" className="contact-card">
            <FaWhatsapp className="contact-icon whatsapp" />
            <span>Chat on WhatsApp</span>
          </a>
          
          <a href="mailto:info@codexlnc.com" className="contact-card">
            <FaEnvelope className="contact-icon email" />
            <span>Email Us</span>
          </a>
          
          <a href="https://www.linkedin.com/in/malyala-kalyan-chakravarthy-goud-844745219/" className="contact-card">
            <FaLinkedin className="contact-icon linkedin" />
            <span>Connect on LinkedIn</span>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutCodeXLNC;